import React, { useState } from 'react';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { selectShowRegionSelection } from 'tradera/state/shipping-region/selectors';
import { useTranslator } from 'tradera/lang/translate';
import DropdownIcon from '@tradera/blueprint/theme/icons2/dropdown.svg?jsx';
import { LocalizationMenu } from 'tradera/legacy/static/components/localization/localization-menu';
import HoverMenu from 'tradera/components/site-header/hover-menu/hover-menu';
import styles from './footer-localization-link.module.scss';
import TranslateIcon from '@tradera/blueprint/theme/icons2/translate.svg?jsx';
import { useAppSelector } from 'tradera/state/hooks';
import { Button } from '../atoms/button/button';

const trackAnalytics = (visible: boolean) => {
    const label = visible ? 'Open' : 'Close';
    GtmService.trackAction('Footer', 'Localization menu', label);
};

type FooterLocalizationLinkProps = {
    className?: string;
};

export const FooterLocalizationLink = ({
    className
}: FooterLocalizationLinkProps) => {
    const { t } = useTranslator();
    const [isLocalizationSettingsVisible, setLocalizationSettingsVisible] =
        useState(false);
    const showRegionSelection = useAppSelector(selectShowRegionSelection);

    const onClick = () => {
        const shouldBeVisible = !isLocalizationSettingsVisible;
        trackAnalytics(shouldBeVisible);
        setLocalizationSettingsVisible(shouldBeVisible);
    };

    const title = showRegionSelection
        ? t('footer_localization_regionAndlanguage')
        : t('footer_localization_language');

    return (
        <div
            className={`position-relative ${className}`}
            onMouseLeave={() => setLocalizationSettingsVisible(false)}>
            <HoverMenu
                showMenu={isLocalizationSettingsVisible}
                className={styles.hoverLocalizationMenuFooter}>
                <LocalizationMenu
                    showRegionSelection={showRegionSelection || false}
                />
            </HoverMenu>
            <Button
                theme="text"
                className="mb-2 text-styled d-flex align-items-center"
                icon={<TranslateIcon />}
                onClick={onClick}>
                {title}
                <DropdownIcon className="icon ml-1 icon-xs" />
            </Button>
        </div>
    );
};
